import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrophyAlt,
  faStar,
  faChartLine,
  faTasks,
  faFlagCheckered,
  faArrowAltCircleRight,
  faMapMarkerAlt,
  faCheckCircle,
  faTimesCircle,
  faCar,
  faEye,
  faWrench,
  faExclamationTriangle,
} from '@whitebox-learning/fontawesome-pro-duotone-svg-icons';
import {
  faPencil,
  faSave,
  faSpinnerThird,
  faTimes,
  faFile,
  faBallot,
  faTools,
  faQuestionCircle,
  faWindowClose,
  faPrint,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

import './Icons.scss';

/* General-purpose icons --------------------- */
export const GotoIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faArrowAltCircleRight}
    className={`icon-goto ${className}`}
    {...rest}
  />
);

export const LocationIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faMapMarkerAlt}
    className={`icon-goto ${className}`}
    {...rest}
  />
);

export const SaveIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faSave}
    className={`icon-save ${className}`}
    {...rest}
  />
);

export const PrintIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faPrint}
    className={`icon-print ${className}`}
    {...rest}
  />
);

export const CloseIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faWindowClose}
    className={`icon-close ${className}`}
    {...rest}
  />
);

export const CancelIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faTimes}
    className={`icon-cancel ${className}`}
    {...rest}
  />
);

export const LoadingIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faSpinnerThird}
    className={`icon-loading ${className}`}
    {...rest}
  />
);

export const EditIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faPencil}
    className={`icon-edit ${className}`}
    {...rest}
  />
);

export const HelpIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faQuestionCircle}
    className={`icon-help ${className}`}
    {...rest}
  />
);

export const WarningIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faExclamationTriangle}
    className={`icon-warning ${className}`}
    {...rest}
  />
);

/* Icons specific to WBL functionality ------- */
export const GameModeIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faTrophyAlt}
    className={`icon-game-mode ${className}`}
    {...rest}
  />
);

export const GradesScoreIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faTasks}
    className={`icon-grades-score ${className}`}
    {...rest}
  />
);

export const IterationsScoreIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faFlagCheckered}
    className={`icon-iterations-score ${className}`}
    {...rest}
  />
);

export const PerformanceScoreIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faChartLine}
    className={`icon-performance-score ${className}`}
    {...rest}
  />
);

export const InSpecIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faCheckCircle}
    className={`icon-in-spec ${className}`}
    {...rest}
  />
);

export const OutOfSpecIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faTimesCircle}
    className={`icon-out-of-spec ${className}`}
    {...rest}
  />
);

export const ResearchDocumentIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faFile}
    className={`icon-research-document ${className}`}
    {...rest}
  />
);

export const ResearchActivityIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faBallot}
    className={`icon-research-activity ${className}`}
    {...rest}
  />
);

export const ResearchTutorialIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faTools}
    className={`icon-research-tutorial ${className}`}
    {...rest}
  />
);

export const EyeIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon icon={faEye} className={`icon-eye ${className}`} {...rest} />
);

export const WrenchIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faWrench}
    className={`icon-wrench ${className}`}
    {...rest}
  />
);

/* App-specific icons */
/* todo: create higher-order-component that handles selecting based on app logic */
export const DragsterIcon = ({ className = '', ...rest }) => (
  <FontAwesomeIcon
    icon={faCar}
    className={`icon-dragster ${className}`}
    {...rest}
  />
);
